import type { ListBuilderConfiguration } from '../types';

/**
 * Client List Clients list configuration
 * Shows clients belonging to a specific client list
 * Converted from JSON to TypeScript for type safety
 */
export const CLIENT_LIST_CLIENTS_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-client-list-clients',
			cacheTTL: 600000,
			name: 'Clients in List',
			type: 'default',
			active: true,
			columns: [
				{
					id: 'client-name',
					fields: [
						{
							id: 'name-field',
							link: {
								type: 'object',
								enabled: true,
								objectTable: 'client',
								idField: 'client.id',
							},
							dataConfig: {
								type: 'field',
								field: { fieldName: 'client.name', objectTable: 'client' },
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-1',
							dataConfig: { type: 'custom_text', customText: '' },
							styleConfig: { size: 'md', colorRule: { type: 'default' } },
							displayStyle: 'line_break',
						},
						{
							id: 'address1-field',
							dataConfig: {
								type: 'field',
								field: { fieldName: 'client.address1', objectTable: 'client' },
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'theme', themeColor: 'textSecondary' },
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-2',
							dataConfig: { type: 'custom_text', customText: '' },
							styleConfig: { size: 'md', colorRule: { type: 'default' } },
							displayStyle: 'line_break',
						},
						{
							id: 'city-state-zip-field',
							dataConfig: {
								type: 'template',
								template: '{client.city}, {client.state} {client.zip}',
								templateFields: [],
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'theme', themeColor: 'textSecondary' },
							},
							displayStyle: 'text',
						},
					],
					headers: [{ id: 'h1', text: 'Name' }],
					minWidth: 180,
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'client.name',
							objectTable: 'client',
						},
					],
					widthConfig: { mode: 'flexible', preset: 'large' },
					verticalAlignment: 'top',
				},
				{
					id: 'type-info',
					fields: [
						{
							id: 'lead-customer-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'client.leadOrCustomer',
									objectTable: 'client',
								},
							},
							styleConfig: {
								size: 'xs',
								colorRule: { type: 'value-mapping' },
								valueMapping: [
									{
										color: { type: 'info' },
										value: 'Customer',
									},
									{
										color: { type: 'warning' },
										value: 'Lead',
									},
								],
							},
							displayStyle: 'badge',
						},
						{
							id: 'line-break-2',
							dataConfig: { type: 'custom_text', customText: '' },
							styleConfig: { size: 'md', colorRule: { type: 'default' } },
							displayStyle: 'line_break',
						},
						{
							id: 'business-type-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'client.businessType',
									objectTable: 'client',
								},
							},
							styleConfig: {
								size: 'xs',
								colorRule: {
									type: 'static',
									staticColor: { type: 'neutral' },
								},
							},
							displayStyle: 'badge',
						},
					],
					headers: [{ id: 'h2', text: 'Type' }],
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'client.leadOrCustomer',
							objectTable: 'client',
						},
					],
					widthConfig: { mode: 'flexible', preset: 'medium' },
					verticalAlignment: 'top',
				},
				{
					id: 'contact-info',
					fields: [
						{
							id: 'phone-field',
							dataConfig: {
								type: 'field',
								field: { fieldName: 'client.phone', objectTable: 'client' },
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-3',
							dataConfig: { type: 'custom_text', customText: '' },
							styleConfig: { size: 'md', colorRule: { type: 'default' } },
							displayStyle: 'line_break',
						},
						{
							id: 'email-field',
							dataConfig: {
								type: 'field',
								field: { fieldName: 'client.email', objectTable: 'client' },
							},
							styleConfig: {
								size: 'xs',
								colorRule: { type: 'theme', themeColor: 'textSecondary' },
							},
							displayStyle: 'text',
						},
					],
					headers: [{ id: 'h3', text: 'Contact' }],
					sortable: false,
					alignment: 'left',
					widthConfig: { mode: 'flexible', preset: 'medium' },
					verticalAlignment: 'top',
				},
				{
					id: 'salespeople',
					fields: [
						{
							id: 'salesperson-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'client.salespersonName',
									objectTable: 'client',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
							},
							displayStyle: 'text',
						},
					],
					headers: [{ id: 'h4', text: 'Sales Rep' }],
					sortable: false,
					alignment: 'left',
					widthConfig: { mode: 'flexible', preset: 'medium' },
					verticalAlignment: 'top',
				},
				{
					id: 'actions',
					minWidth: 120,
					fields: [
						{
							id: 'remove-action',
							dataConfig: { type: 'custom_text', customText: 'Remove' },
							styleConfig: {
								size: 'sm',
								iconName: 'faTrash',
								variant: 'outline',
								colorRule: { type: 'theme', themeColor: 'danger' },
							},
							displayStyle: 'button',
							link: {
								enabled: true,
								type: 'callback',
								callbackName: 'removeClient',
							},
						},
					],
					headers: [{ id: 'h5', text: '' }],
					sortable: false,
					alignment: 'right',
					widthConfig: { mode: 'fixed', width: 120 },
					verticalAlignment: 'top',
				},
			],
			description: 'Clients belonging to a specific client list',
			defaultSortId: 'name-asc',
			requiredFields: [
				'client._id',
				'client.id',
				'client.name',
				'client.address1',
				'client.city',
				'client.state',
				'client.zip',
				'client.phone',
				'client.email',
				'client.leadOrCustomer',
				'client.businessType',
				'client.salespersonName',
			],
			sortOrder: 0,
		},
	],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [25, 50, 100],
	},
	filters: {
		activeFilters: [],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/clients/:id',
			objectLabel: 'Client',
			objectTable: 'client',
			selectedFields: [
				{ fieldName: 'id', fieldLabel: 'ID' },
				{ fieldName: '_id', fieldLabel: 'Internal ID' },
				{ fieldName: 'name', fieldLabel: 'Name' },
				{ fieldName: 'address1', fieldLabel: 'Address' },
				{ fieldName: 'city', fieldLabel: 'City' },
				{ fieldName: 'state', fieldLabel: 'State' },
				{ fieldName: 'zip', fieldLabel: 'Zip' },
				{ fieldName: 'phone', fieldLabel: 'Phone' },
				{ fieldName: 'email', fieldLabel: 'Email' },
				{ fieldName: 'leadOrCustomer', fieldLabel: 'Lead/Customer' },
				{ fieldName: 'businessType', fieldLabel: 'Business Type' },
				{ fieldName: 'salespersonName', fieldLabel: 'Sales Rep' },
			],
		},
	],
	tableSorts: [
		{
			id: 'name-asc',
			name: 'Name (A-Z)',
			fields: [
				{ direction: 'ASC', fieldName: 'client.name', objectTable: 'client' },
			],
			description: 'Sort clients by name',
		},
		{
			id: 'name-desc',
			name: 'Name (Z-A)',
			fields: [
				{ direction: 'DESC', fieldName: 'client.name', objectTable: 'client' },
			],
			description: 'Sort clients by name descending',
		},
		{
			id: 'type-asc',
			name: 'By Type',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'client.leadOrCustomer',
					objectTable: 'client',
				},
				{ direction: 'ASC', fieldName: 'client.name', objectTable: 'client' },
			],
			description: 'Sort by lead/customer then name',
		},
	],
};
